import module from 'contabilidad/clientescuentascontables/module.js'
import template from './template.html'

export class ContabilidadClientescuentascontablesDetalleEditarComponent {
  idCliente
  idProveedor
  idAdministrador
  idCuenta
  clasificacion
  codigoConcepto
  data = null
  promise = null
  procesando = false
  error = null
  respuesta = null
  catalogo = {
    clientes: [],
    cuentasBancarias: [],
    conceptosContables: [],
  }

  constructor ($q, $state, $catalogos, $notify, ContabilidadClientesCuentasContables) {
    this.$q = $q
    this.$state = $state
    this.$catalogos = $catalogos
    this.$notify = $notify
    this.ContabilidadClientesCuentasContables = ContabilidadClientesCuentasContables
  }

  $onInit () {
    this.promise = this.$q.all([
      this.ContabilidadClientesCuentasContables.obtenerCuentaContable(this.idCliente, this.idProveedor, this.idAdministrador, this.idCuenta, this.clasificacion, this.codigoConcepto)
        .then(({data}) => (this.data = data)),
      this.ContabilidadClientesCuentasContables.obtenerConceptosFacturacion()
        .then(({data}) => (this.catalogo.conceptosContables = data)),
      this.$catalogos.get('clientes')
        .then((data) => (this.catalogo.clientes = data)),
      this.$catalogos.get('cuentasBancarias')
        .then((data) => (this.catalogo.cuentasBancarias = data)),
    ])
  }

  editar () {
    if (this.procesando) return
    this.procesando = true

    this.ContabilidadClientesCuentasContables.editarCuentasContable(this.idCliente, this.idProveedor, this.idAdministrador, this.idCuenta, this.clasificacion, this.codigoConcepto, this.data)
      .then(({data}) => (this.respuesta = data))
      .catch(({data}) => (this.$notify.error(data)))
      .finally(() => (this.procesando = false))
  }

  cancelar () {
    this.$state.go('contabilidad.clientesCuentasContables.cliente.cuentas')
  }
}

module.component('contabilidadClientescuentascontablesDetalleEditar', {
  controller: ContabilidadClientescuentascontablesDetalleEditarComponent,
  template,
  bindings: {
    idCliente: '<',
    idProveedor: '<',
    idAdministrador: '<',
    idCuenta: '<',
    clasificacion: '<',
    codigoConcepto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/clientescuentascontables/components/detalle/editar/component.js